import { createStyles } from '@mantine/core';

export const HEADER_MAX_WIDTH = 1600;
export const HEADER_SIDE_SLOT_SIZE_DESKTOP = 72;
export const HEADER_SIDE_SLOT_SIZE_MOBILE = 48;
export const HEADER_HEIGHT_DESKTOP = HEADER_SIDE_SLOT_SIZE_DESKTOP;
export const HEADER_HEIGHT_MOBILE = HEADER_SIDE_SLOT_SIZE_MOBILE;

const useStyles = createStyles((theme, _, getRef) => ({
  container: {
    height: HEADER_HEIGHT_DESKTOP,
    background: theme.colors.gray[9],

    [theme.fn.smallerThan('md')]: {
      height: HEADER_HEIGHT_MOBILE,
    },
  },
  desktop: {
    height: '100%',

    [theme.fn.smallerThan('md')]: {
      display: 'none',
    },
  },
  mobile: {
    width: '100%',
    overflow: 'hidden',
    [theme.fn.largerThan('md')]: {
      display: 'none',
    },
  },
  content: {
    display: 'grid',
    gridTemplateColumns: `${HEADER_SIDE_SLOT_SIZE_DESKTOP}px 1fr ${HEADER_SIDE_SLOT_SIZE_DESKTOP}px`,
    maxWidth:
      theme.other.layout.maxWidth +
      HEADER_SIDE_SLOT_SIZE_DESKTOP * 2 -
      theme.other.layout.paddingLg * 2,
    margin: '0 auto',

    [theme.fn.smallerThan('md')]: {
      gridTemplateColumns: `${HEADER_SIDE_SLOT_SIZE_MOBILE}px 1fr ${HEADER_SIDE_SLOT_SIZE_MOBILE}px`,
    },
  },
  closeLink: {
    width: HEADER_SIDE_SLOT_SIZE_DESKTOP,
    height: HEADER_SIDE_SLOT_SIZE_DESKTOP,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',

    '@media (hover: hover)': {
      '& svg': {
        transition: 'stroke 0.1s ease-in-out',
      },

      '&:hover svg': {
        stroke: theme.colors.blue[3],
      },
    },

    [theme.fn.smallerThan('md')]: {
      width: HEADER_SIDE_SLOT_SIZE_MOBILE,
      height: HEADER_SIDE_SLOT_SIZE_MOBILE,
    },
  },
  info: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    height: '100%',
  },
  titleLink: {
    color: theme.white,
    textDecoration: 'none',

    '@media (hover: hover)': {
      transition: 'color 0.1s ease-in-out',
      '&:hover': {
        color: theme.colors.blue[3],

        [`& .${getRef('titleIcon')}`]: {
          stroke: theme.colors.blue[3],
        },
      },
    },
  },
  titleIcon: {
    ref: getRef('titleIcon'),
    transition: 'stroke 0.1s',
    stroke: theme.colors.gray[3],
  },
  stats: {
    display: 'flex',
    alignItems: 'center',
    height: '100%',
  },
  stat: {
    display: 'flex',
    flexDirection: 'column',
    paddingLeft: theme.spacing.md,

    '&:not(:last-child)': {
      paddingRight: theme.spacing.md,
      borderRight: `1px solid ${theme.colors.gray[7]}`,
    },
  },
  mobileInfoLink: {
    display: 'flex',
    height: '100%',
    alignItems: 'center',
    justifyContent: 'center',
  },
}));

export default useStyles;
